<template>
  <div class="moow-master-container play-background">

    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container class="moow-resp-container dashboard-container">
      <div class="md-layout">
        <div class="md-layout-item">
          <property-selector ref="propertySelectorRef"/>        
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item">
        </div>
        <div class="md-layout-item" style="text-align:right">
          <md-button
            @click="chooseProperty()"
            class="md-primary play-cta-button makeup"
          >Next</md-button>
        </div>
      </div>
    </b-container>

    <error-snackbar
      :message="snackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showSnackbar"
      position="center"
      :isInfinity="false">
    </error-snackbar>
  </div>
</template>

<script>
  import PropertySelector from '@/components/property/propertySelector.vue'
  import Snackbar from '@/components/snackbar.vue'
  import { getHouseRulesFrom } from '@/platform/properties/transformers/import/propertyTransformer'
  export default {
    props: {

    },
    components: {
      'error-snackbar': Snackbar,
      'property-selector': PropertySelector
    },
    data() {
      return {
        loading: true,
        selectedProperty: undefined,
        snackbarMessage: "",
        showSnackbar: false
      }
    },
    filters: {
    },
    mounted(){
      this.loading=false
      
    },
    created(){
      this.mapUrlParamsToForm()
    },
    watch:{
    },
    computed: {
    },
    methods: {
      chooseProperty(){
        var property = this.$refs.propertySelectorRef.getSelectedProperty()
        if(property){
          this.$store.commit("DA_SET_PROPERTY", property )
          this.next()
        } else this.displayMessage("Select property")
      },
      next(){
        this.$store.commit("DA_RESET_LESSOR")
        this.changeView("dealApplicationLessor")
      },
      displayMessage(message){
        this.snackbarMessage = message
        this.showSnackbar=true
      },
      changeView(name, params){
        this.$router.push({
          name: name,
          params: params
        })
      },
    }
  }
</script>
<style scoped>
  @import '../../../assets/styles/booking.css';
  @import '../../../assets/styles/dashboard.css';
  @import '../../../assets/styles/global.css';
</style>



// WEBPACK FOOTER //
// src/components/bookings/deals/DealApplicationProperty.vue